<template>
    <div :width="width+'px'" :heigth="width+'px'" class="gauge-chart-container">
        <div class="heading">{{this.heading}}</div>
        <div class="chart-wrapper">
            <div>
                <VueSvgGauge
                        :width="width+'px'" :heigth="width+'px'"
                        :start-angle="-130"
                        :end-angle="130"
                        :value="value"
                        :separator-step="0"
                        :min="0"
                        :innerRadius="70"
                        :max="maxValue"
                        :gauge-color="[{ offset: 0, color: '#da2567'}, { offset: 50, color: '#b92972'},{ offset: 100, color: '#752b77'}]"
                        :scale-interval="0"
                >
                </VueSvgGauge>
                <div class="inner-text">
                    <div class="gauge-chart-text" v-html="text">
                    </div>
                    <div class="gauge-chart-text-info" v-html="details">
                    </div>
                    <div class="gauge-chart-text-info bold" v-html="percentage">
                    </div>
                </div>
            </div>
            <img :style="rotate" class="pointer" alt="" src="../../assets/images/gaugeSharp.png">

        </div>

    </div>


</template>

<script>
    import {VueSvgGauge} from 'vue-svg-gauge'

    export default {
        name: 'GaugeChart',
        components: {
            VueSvgGauge
        },
        props: {
            value: {
                required: true,
                type: Number
            },
            maxValue: {
                required: true,
                type: Number
            },
            text: {
                required: true,
                type: String
            },
            heading: {
                required: false,
                type: String
            },
            details: {
                required: true,
                type: String
            },
            percentage: {
                required: true,
                type: String
            },
            width: {
                type: Number,
                default: 300
            }
        },
        data() {
            return {
                options: {
                    lineWidth: 0.25,
                    angle: -0.3,
                    pointer: {
                        length: 0.3,
                        strokeWidth: 0.04
                    },
                    colorStart: 'black',
                    colorStop: '#d70364',
                    strokeColor: '#eceef0',
                    generateGradient: true,
                    percentColors: [
                        [0.0, "#da2567"],
                        [0.50, "#b92972"],
                        [1.0, "#752b77"]
                    ]
                }
            };
        },
        computed: {
            rotate() {
                let percentage = this.value / this.maxValue;
                if(this.value >= this.maxValue){
                   percentage = 1;
                }
                let rotateDeg = 270 * percentage + 42;
                return Object.assign({'transform': 'rotate(' + rotateDeg + 'deg)',transition: 'transform .8s linear'});
            }
        }
    };
</script>

<style lang="scss" scoped>

    ::v-deep .gauge-title {
        display: none;
    }

    .gauge-chart-text-container {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }

    .gauge-chart-text {
        font-size: 36px;
        color: $darkGrey
    }

    .gauge-chart-text-info {
        font-size: 12px;
    }

    .gauge-chart-container {
        background-color: white;
        padding: 12px;
        position: relative;
    }

    .inner-text {
        position: absolute;
        bottom: 10px;
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }

    .pointer {
        transform: rotate(0deg);
        position: absolute;
        width: 47%;
        top: 30%;
        left: 25%;
        -webkit-transition: -webkit-transform .8s linear;
        transition: transform .8s linear;
    }

    .chart-wrapper{
        padding: 1em;
    }

    .heading{
        font-weight: bold;
        font-size: .9em;
    }

    .bold{
        font-weight: bold;
    }

    .gauge-chart-text{
        font-size: 1.6em;
    }

    @media (max-width: 767px) {
        .gauge-chart-text{
            font-size: 1.2em;
        }
    }
</style>